import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text24 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {stopConditionsAppendix} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(stopConditionsAppendix) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={styles.bold}>נספח תנאים מתלים ומפסיקים: </span>
          <span>{getBreakLinesTextShumaType3(stopConditionsAppendix)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text24;
